<template>
	<div class="card-list">
        <div
            v-for="item in items"
            :key="item.id"
            @click="toRouterPage(item.lmsLink || item.id)"
            class="card-list__card"
            :class="{'pointer': (lms && item.lmsLink) || (routerTo && item.id)}"
        >
            <div class="card-list__card-top">
                <img
                    :alt="item.name"
                    :src="item.image || require('../../../assets/images/no-picture.svg')"
                    class="card-list__card-top-img"
                >
                <div class="card-list__card-top-info">
                    <h3 class="card-list__card-top-info-title">
                        {{ item.name | ellipsis(isMobile ? 59 : 76) }}
                    </h3>
                    <div v-if="!isMobile" class="card-list__card-top-info-description">
                        {{ extractContent(item.description) }}
                    </div>
                </div>
            </div>
            <div class="card-list__card-bottom" :class="{'registration-is': isMobile && registration}">
                <div class="active" v-if="tabType === 'active' || !finishedBtnText">
                    <img
                        :alt="item.name"
                        class="card-list__card-bottom-img"
                        src="~@/assets/images/tabs-card-play.svg"
                    >
                    <span class="card-list__card-bottom-link">{{ continueBtnText }}</span>
                </div>
                <div v-else class="finished">
                    <img
                        :alt="item.name"
                        class="card-list__card-bottom-img"
                        src="~@/assets/images/porject-finish-icon.svg">
                    <span class="card-list__card-bottom-link">{{ finishedBtnText }}</span>
                </div>
                <div 
                    v-if="registration"
                    class="card-list__card-bottom-registration"
                >
                    Открыта регистрация
                </div>
            </div>
        </div>
        <div class="center">
            <div
                v-if="loadMore"
                class="card-list__load-more"
                @click="loadMoreCards"
            >
                {{ loadMoreTxt }}
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = ['isMobile'];

export default {
    name: 'CardList',
    props: {
        items: [],
        continueBtnText: {
            type: String,
            default: '',
        },
        finishedBtnText: {
            type: String,
            default: '',
        },
        registration: {
            type: Boolean,
            default: false,
        },
        loadMore: {
            type: Boolean,
            default: false,
        },
        loadMoreTxt: {
            type: String,
            default: '',  
        },
        routerTo: {
            type: String,
            default: '',
        },
        tabType: {
            type: String,
            default: '',
        },
        lms: {
            type: Boolean,
            default: false,
        },
        descriptionType: {
            type: String,
            default: 'string',
        },
    },
    data: () => ({
        
    }),
    methods: {
        loadMoreCards() {
            this.$emit('loadMoreCards', true);
        },
        toRouterPage(data) {
            if (this.lms && typeof data === 'string') {
                window.open(data, '_blank');
            } else if (this.routerTo) {
                window.location = `${this.routerTo}${data}`;
            }
        },
        extractContent(string) {
            const isStringDesc = this.descriptionType === 'string';
            let span = document.createElement('span');
            span.innerHTML = string;
            return this.ellipsis(span.textContent, isStringDesc ? 120 : 100) || this.ellipsis(span.innerText, isStringDesc? 120 : 100);
        },
    },
    computed: {
        ...mapGetters(getters),
    },
};
</script>

<style scoped lang="scss">
    @import "../../../styles/variables";
    @import '../../../styles/rem';
    @import '../../../styles/mrem';

    .card-list {

        &__card {
            display: block;
            position: relative;
            background: #F6F9FF;
            padding: mrem(20);
            margin-bottom: mrem(32);
            min-height: mrem(230);
            border-radius: mrem(10);
            box-shadow: mrem(0) mrem(6) mrem(10) rgba(131, 134, 163, 0.12);

            @include on-desktop {
                padding: rem(20);
                margin-bottom: rem(32);
                height: rem(230);
                min-height: rem(230);
                border-radius: rem(10);
                box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.12);
                
                &:hover {
                    box-shadow: rem(0) rem(6) rem(10) rgba(131, 134, 163, 0.2);
                }
            }

            &-top {
                

                @include on-desktop {
                    display: flex;
                }

                &-img {
                    height: mrem(124);
                    width: mrem(220);
                    min-width: mrem(220);
                    margin-left: mrem(48);
                    border-radius: mrem(10);

                    @include on-desktop {
                        height: rem(124);
                        width: rem(220);
                        min-width: rem(220);
                        margin-right: rem(20);
                        margin-left: rem(0);
                        border-radius: rem(10);
                    }
                }
                
                &-info {

                    &-title {
                        margin: 0;
                        font-style: normal;
                        font-weight: 700;
                        font-size: mrem(21);
                        line-height: mrem(25);
                        color: #000000;
                        max-height: mrem(50);
                        overflow: hidden;
                        text-align: center;
                        margin: mrem(16) 0 mrem(16) mrem(0);

                        @include on-desktop {
                            text-align: left;
                            margin: rem(4) 0 rem(16) 0;
                            font-size: rem(21);
                            line-height: rem(25);
                            max-height: rem(50);
                        }
                    }

                    &-description {
                        height: rem(40);
                        overflow: hidden;
                        font-style: normal;
                        font-weight: 350;
                        font-size: rem(16);
                        line-height: rem(20);
                        color: #2A2626;
                    }
                }
            }

            &-bottom {
                display: flex;
                align-items: center;
                justify-content: center;
                

                @include on-desktop {
                    position: absolute;
                    bottom: rem(20);
                    padding-left: rem(0);
                }

                &-img {
                    width: mrem(20);
                    height: mrem(20);
                    margin-right: mrem(10);

                    @include on-desktop {
                        width: rem(20);
                        height: rem(20);
                        margin-right: rem(10);
                    }
                }

                &-link {
                    color: #000000;
                    font-style: normal;
                    font-weight: normal;
                    font-size: mrem(18);
                    line-height: mrem(26);

                    @include on-desktop {
                        font-size: rem(18);
                        line-height: rem(26);
                    }
                }

                &-registration {
                    text-align: center;
                    color: #FFFFFF;
                    font-style: normal;
                    font-weight: 700;
                    position: absolute;
                    width: mrem(163);
                    height: mrem(34);
                    left: mrem(192);
                    bottom: mrem(0);
                    background: #68C87A;
                    border-radius: mrem(10) 0;
                    font-size: mrem(14);
                    padding: mrem(4) mrem(8);
                    line-height: mrem(26);

                    @include on-desktop {
                        position: absolute;
                        left: rem(534);
                        top: rem(12);
                        padding: rem(4) rem(8);
                        width: rem(153);
                        height: rem(34);
                        background: #68C87A;
                        border-radius: rem(10) 0;
                        font-size: rem(14);
                        line-height: rem(26);
                    }
                }
            }
        }

        &__load-more {
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: mrem(206);
            height: mrem(43);
            border: mrem(1) solid #98A0A9;
            border-radius: mrem(4);
            font-style: normal;
            font-weight: 400;
            font-size: mrem(18);
            line-height: mrem(23);
            padding-top: mrem(3);
            color: #98A0A9;


            &::before {
                content: " ";
                margin-top: mrem(-3);
                margin-right: mrem(8);
                left: mrem(20);
                display: block;
                width: mrem(22);
                height: mrem(16);
                background: url('~@/assets/images/load-more.svg') no-repeat;
                background-size: mrem(23) mrem(16);
            }

            @include on-desktop {
                justify-content: center;
                padding-top: rem(3);
                width: rem(206);
                height: rem(43);
                margin-top: rem(-3);
                border: rem(1) solid #98A0A9;
                border-radius: rem(4);
                font-size: rem(18);
                line-height: rem(23);

                &::before {
                    content: " ";
                    margin-top: rem(-3);
                    margin-right: rem(8);
                    left: rem(20);
                    display: block;
                    width: rem(22);
                    height: rem(16);
                    background: url('~@/assets/images/load-more.svg') no-repeat;
                    background-size: rem(23) rem(16);
                }
            }
        }
    }

    .pointer {
        cursor: pointer;
    }

    .center {
        display: flex;
        justify-content: center;
    }
    
    .registration-is {
        margin-bottom: mrem(28);

        @include on-desktop {
            margin-bottom: inherit;
        }
    }

    .active, .finished {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
